import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { isPlatform } from '@ionic/react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ObservableCacheProvider } from './cache/observable-cache-provider';
import { ApplicationConfig } from './config/config';
import { KioskManager } from './kiosk/kiosk-manager';
import * as serviceWorker from './serviceWorker';

const isKioskModeEnabled = ApplicationConfig.kiosk.enabled;

const container = document.getElementById('root');

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <ObservableCacheProvider>
    <KioskManager enabled={isKioskModeEnabled}>
      <App />
    </KioskManager>
  </ObservableCacheProvider>
);

interface ServiceWorkerEventTarget {
  state: string;
}

// only enable service worker if we are not in kiosk mode and not in capacitor
const enableServiceWorker = !isKioskModeEnabled && !isPlatform('capacitor');

if (enableServiceWorker) {
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.register({
    onUpdate: (registration) => {
      const waitingServiceWorker = registration.waiting;

      if (waitingServiceWorker) {
        waitingServiceWorker.addEventListener('statechange', (event) => {
          const target: ServiceWorkerEventTarget =
            event.target as unknown as ServiceWorkerEventTarget;
          if (target?.state === 'activated') {
            window.location.reload();
          }
        });
        waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      }
    },
  });
}

// PWA elements: https://capacitorjs.com/docs/pwa-elements
defineCustomElements(window);
